<script>
import {
  BButton, BCard, BCardTitle, BCardSubTitle, BCardText, BCardBody,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BButton, BCard, BCardTitle, BCardSubTitle, BCardText, BCardBody,
  },
  data() {
    return {
      isLoading: true,
      error: null,
      success: false,
    }
  },
  async mounted() {
    try {
      const { code } = this.$route.query
      // const authStore = useAuthStore()

      if (!code) {
        this.error = 'Authorization code not found'
        this.isLoading = false
        return
      }

      const params = {
        code,
        // ensure string input and provide radix for parseInt
        client_id: parseInt(String(process.env.VUE_APP_CLIENT_ID), 10),
        client_secret: String(`${process.env.VUE_APP_CLIENT_SECRET}` || ''),
      }

      const { data } = await this.$store.dispatch('auth/exchangeCodeForToken', params)

      if (data.success) {
        this.success = true
        useJwt.getProfile().then(profile => {
          const userData = {
            id: profile.data.data.id,
            fullName: profile.data.data.name,
            username: profile.data.data.name,
            avatar: profile.data.data.photo,
            email: profile.data.data.email,
            data: profile.data.data,
            role: profile.data.data.roles.name,
            ability: [
              {
                action: 'manage',
                subject: 'all',
              },
            ],
          }
          localStorage.setItem('sesnotify', 'on')
          localStorage.setItem('userData', JSON.stringify(userData))
          this.$ability.update(userData.ability)
        })
        setTimeout(() => {
          const redirectTo = this.$route.query.state || '/dashboard/sparing'
          this.$router.push(redirectTo)
        }, 1500)
      } else {
        this.error = data?.error?.message || 'Authentication failed'
      }
    } catch (err) {
      this.error = err?.data?.error?.message || 'An unexpected error occurred'
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    retryAuth() {
      window.location.href = '/'
    },
  },
}
</script>

<template>
  <div class="flex min-h-screen items-center justify-center bg-muted/50 p-4">
    <b-card class="w-full max-w-md">
      <b-card-body class="space-y-4">
        <b-card-title class="text-2xl font-bold">
          Authenticating...
        </b-card-title>
        <b-card-sub-title>Please wait while we complete your authentication</b-card-sub-title>
        <b-card-text>
          <div
            v-if="isLoading"
            class="flex flex-col items-center space-y-4"
          >
            <!-- <Loader2 class="h-8 w-8 animate-spin text-primary" /> -->
            <p class="text-sm text-muted-foreground">
              Processing authorization code...
            </p>
          </div>

          <div
            v-else-if="success"
            class="flex flex-col items-center space-y-4"
          >
            <!-- <CheckCircle class="h-8 w-8 text-green-500" /> -->
            <p class="text-sm text-green-600">
              Authentication successful!
            </p>
            <p class="text-xs text-muted-foreground">
              Redirecting to dashboard...
            </p>
          </div>

          <div
            v-else-if="error"
            class="flex flex-col items-center space-y-4"
          >
            <!-- <AlertCircle class="h-8 w-8 text-red-500" /> -->
            <p class="text-sm text-red-600">
              {{ error }}
            </p>
            <b-button
              variant="outline"
              size="sm"
              @click="retryAuth"
            >
              Try Again
            </b-button>
          </div>
        </b-card-text>
      </b-card-body>
    </b-card>
  </div>
</template>
